var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vasion-flex"},[_c('router-view',{staticClass:"vasion-remaining-after-two-subnavs"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }